import cloneDeep from 'lodash/cloneDeep';

import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { generateFormObject } from '@/core/tools/forms/generate_form_object';
import { prepareFormObjectForSave } from '@/core/tools/forms/prepare_form_object_for_save';

import numeral from 'numeral';
import moment from "moment";

interface WarehouseResortMultipleFormState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documents: any[];
    forms: any[];
    schema: any;
    warehouse_id: string;
    resort_date: Date | null;
    group_key: string;
    targetForDelete: any[];

    meta: any;
}

const state: WarehouseResortMultipleFormState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documents: [],
    forms: [],
    schema: null,
    warehouse_id: '',
    resort_date: null,
    group_key: '',
    targetForDelete: [],

    meta: {},
};

const initState: WarehouseResortMultipleFormState = cloneDeep(state);

export const WAREHOUSES_RESORT_DATA = 'GET_WAREHOUSES_RESORT_DATA';
export const WAREHOUSES_RESORT_SCHEMA = 'GET_WAREHOUSES_RESORT_SCHEMA';

export const actions: ActionTree<WarehouseResortMultipleFormState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    prepareNew({ commit, state }, initParams) {
        const vm = (this as any)._vm;

        console.log(initParams)

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(WAREHOUSES_RESORT_SCHEMA)
                    .raw('schemas.get')
                    .action({
                        id: `s:warehouses_resort`
                    }),
            ]).then((result: ServerResult) => {
                commit('GENERATE_FORM_DATA', {
                    ...result.getOperation(WAREHOUSES_RESORT_SCHEMA).getContent(),
                    initParams
                });

                commit('LOADED_SUCCESS');
                resolve();
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    loadData({ commit, state }, {initParams, group_key}) {
        const vm = (this as any)._vm;

        console.log(group_key)

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(WAREHOUSES_RESORT_DATA)
                    .raw('documents.list')
                    .action({
                        "columns": {
                            id: 'mv.id',
                            warehouse_id: 'mv.warehouse_id',
                            product_id: 'mv.product_id',
                            product_container_id: 'mv.product_container_id',
                            quantity: 'mv.quantity',
                            reasone: 'mv.reasone',
                            client_id: 'mv.client_id',
                            deal_id: 'mv.deal_id',
                            manager_id: 'mv.manager_id',
                            created_at: 'mv.created_at',
                            weight: 'mv.weight',
                            from_product_id: 'mv.from_product_id',
                            from_product_container_id: 'mv.from_product_container_id',
                            resort_date: 'mv.resort_date',
                            group_key: 'mv.group_key',
                            resort_type_id: 'mv.resort_type_id',
                        },
                        "from": "s:warehouses_resort",
                        "from_as": "mv",
                        where: {
                            $and: [
                                {$eq: ['mv.group_key', {$: group_key}]},
                                {$null: ['mv.deleted_at']}
                            ]
                        }
                    }),
                    vm.$q(WAREHOUSES_RESORT_SCHEMA)
                        .raw('schemas.get')
                        .action({
                            id: `s:warehouses_resort`
                        }),
            ]).then((result: ServerResult) => {
                initParams.rows = result.getOperation(WAREHOUSES_RESORT_DATA).getContent().documents
                commit('GENERATE_FORM_DATA', {
                    ...result.getOperation(WAREHOUSES_RESORT_SCHEMA).getContent(),
                    initParams
                });

                commit('LOADED_SUCCESS');
                resolve();
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    saveForm({ commit, rootState }) {
        const vm = (this as any)._vm;

        const resort_date = moment(state.resort_date).format('YYYY-MM-DD');
        return new Promise((resolve, reject) => {
            commit('START_LOADING');
            const group_key = state.group_key ? state.group_key : moment().format('YYYY-MM-DD HH:mm:ss');

            const saveQueries = state.forms.map((form: any, idx: number) => {
                const normalizedForm = prepareFormObjectForSave(state.schema, form);
                normalizedForm.warehouse_id = state.warehouse_id;
                normalizedForm.resort_date = resort_date
                // @ts-ignore
                normalizedForm.manager_id = rootState.ubic.actor.document.id
                normalizedForm.group_key = group_key

                let saveQuery = null;
                if (form.id) {
                    saveQuery = vm.$q(`WAREHOUSES_DATA_SAVE-${idx}`)
                        .update(form.id, normalizedForm)
                } else {
                    saveQuery = vm.$q(`WAREHOUSES_DATA_SAVE-${idx}`)
                        .create('s:warehouses_resort', normalizedForm)
                }
                return saveQuery
            })
            state.targetForDelete.forEach((id: any, idx: number) => {
                saveQueries.push(
                    vm.$q(`WAREHOUSES_DATA_SAVE-d-${idx}`)
                        .update(id, {deleted_at: moment().format('YYYY-MM-DD HH:mm:ss')})
                )
            })

            vm.$db(saveQueries).then((result: ServerResult) => {
                const operationResult = result.getOperation(result.getOperationNames()[0]);

                if (operationResult.hasError()) {
                    console.log('error', operationResult.getContent());

                    commit('LOADED_SUCCESS');
                    reject();
                } else {
                    commit('ON_FORM_SAVE', operationResult.getContent())

                    commit('LOADED_SUCCESS');
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        })
    },

    changeFormValue({commit}, {field, index, newValue}) {
        commit('CHANGE_VALUE', {field, index, newValue});
    },

    changeAllValue({commit}, {field, newValue}) {
        commit('CHANGE_ALL_VALUE', {field, newValue});
    },

    addForm({commit}) {
        commit('ADD_FORM');
    },

    removeForm({commit}, index) {
        console.log('index', index)
        commit('REMOVE_FORM', index);
    },
};

export const mutations: MutationTree<WarehouseResortMultipleFormState> = {
    RESET_STATE: (state) => {
        for(const key in initState) {
            (state as any)[key] = (initState as any)[key]
        }
    },

    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },

    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },

    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    GENERATE_FORM_DATA(state, {schema, initParams}) {
        state.schema = schema;
        state.meta = fetchEnumsFromSchema(schema);

        if (!initParams.rows || !initParams.rows.length) {
            const row = generateFormObject(schema, initParams);
            row.product_container_weight = 0
            state.forms = [row];
        } else {
            state.warehouse_id = initParams.rows && initParams.rows.length ? initParams.rows[0].warehouse_id : null
            state.resort_date = moment(initParams.rows[0].resort_date).toDate()
            state.group_key = initParams.rows[0].group_key
            console.log(initParams)
            state.forms = initParams.rows.map((row: any) => {
                row = generateFormObject(schema, row);
                row.product_container_weight = 0
                return row
            })
        }
    },

    ADD_FORM(state) {
        state.forms.push(generateFormObject(state.schema, {}));
    },

    REMOVE_FORM(state, index) {
        if (state.forms[index].id) {
          state.targetForDelete.push(state.forms[index].id)
        }
        state.forms.splice(index, 1)
    },

    ON_FORM_SAVE(state, {schema}) {
        state.schema = schema;

    },

    CHANGE_VALUE(state: WarehouseResortMultipleFormState, {field, index, newValue}) {
        switch (field) {
            case 'quantity':
                state.forms[index][field] = numeral(newValue.replace(',', '.')).value();
                // @ts-ignore
                state.forms[index].weight = (numeral(state.forms[index][field]).value() * numeral(state.forms[index].product_container_weight).value()).toFixed(2)
                break;

            case 'weight':
                state.forms[index][field] = numeral(newValue.replace(',', '.')).value();
                // @ts-ignore
                state.forms[index].quantity = MathMath.ceil(numeral(state.forms[index][field]).value() / numeral(state.forms[index].product_container_weight).value())
                break;

            case 'product_container_weight':
                state.forms[index][field] = newValue;
                // @ts-ignore
                state.forms[index].weight = Math.round(state.forms[index].quantity * state.forms[index].product_container_weight * 100) / 100
                break;

            default:
                state.forms[index][field] = newValue;
        }
    },

    CHANGE_ALL_VALUE(state: WarehouseResortMultipleFormState, {field, newValue}) {
        switch (field) {
            case 'warehouse_id':
                state.warehouse_id = newValue
                break;
            case 'resort_date':
                state.resort_date = newValue
                break;

        }
    },
};

const getters = {
    fields: (state: WarehouseResortMultipleFormState) => {
        return state.schema.fields.reduce((prev: any, field: any) => {
            prev[field.code] = field;
            return prev;
        }, {});
    },
};

export const STORE_KEY = '$_warehouse_resort_multiple_form';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
